'use client';

import { useMemo, type ReactNode } from 'react';

import { ContextMap as ContextMapCard } from '@/components/ui/context-map-clean';
import type { ContextMap } from '@/types/chat';

import {
  CONTEXT_MAP_KIND_LABELS,
  contextMapModelName,
} from '../utils/contextMap';

/**
 * What filled Connie's context window on a turn (FSI #1224), on the affectUI Context
 * Map. Opened from the Usage row. When the turn's save dropped old turns, Before shows
 * the window as Connie used it and After shows what she keeps for the next question.
 * `footer` (the usage line) sits under the map as part of the same card.
 */
export const ConnieContextMap = ({
  map,
  footer,
}: {
  map: ContextMap;
  footer?: ReactNode;
}) => {
  const { blocks, compaction } = useMemo(() => {
    if (!map.trimmed?.length)
      return { blocks: map.blocks, compaction: undefined };
    const dropped = new Set(map.trimmed);
    return {
      blocks: map.blocks.filter(block => !dropped.has(block.id)),
      compaction: { before: map.blocks, dropped: map.trimmed },
    };
  }, [map]);

  return (
    <div className='connie-context-map w-full max-w-full' data-cy='context-map'>
      <ContextMapCard
        title="What Connie's holding in mind"
        model={map.model ? contextMapModelName(map.model) : undefined}
        limit={map.limit}
        blocks={blocks}
        compaction={compaction}
        kindLabels={CONTEXT_MAP_KIND_LABELS}
      />
      {footer ? (
        <div className='connie-context-map__footer'>{footer}</div>
      ) : null}
    </div>
  );
};
